import React, { type ComponentType, lazy, Suspense } from 'react';

import Loadable from 'react-loadable';

import { fg } from '@atlaskit/platform-feature-flags';

import type { FeedbackCollectorProps } from './types';

const FeedbackDialogSuspense = lazy(
	() => import(/* webpackChunkName: "async-ptc_feedback-dialog" */ './FeedbackCollector'),
);

const FeedbackDialogLazyNext = (props: FeedbackCollectorProps): React.ReactElement => (
	<Suspense fallback={null}>
		<FeedbackDialogSuspense {...props} />
	</Suspense>
);

const FeedbackDialogLazyLegacy: ComponentType<FeedbackCollectorProps> & Loadable.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "async-ptc_feedback-dialog" */ './FeedbackCollector'),
		loading: () => null,
	});
FeedbackDialogLazyLegacy.displayName = 'lazy(FeedbackDialog)';

const FeedbackDialogLazy: ComponentType<FeedbackCollectorProps> = (
	props: FeedbackCollectorProps,
): React.ReactElement =>
	fg('teams_app_react_19_upgrade') ? (
		<FeedbackDialogLazyNext {...props} />
	) : (
		<FeedbackDialogLazyLegacy {...props} />
	);
FeedbackDialogLazy.displayName = 'lazy(FeedbackDialog)';

export default FeedbackDialogLazy;
